
// This is the custom header search Drawer file just for use before complete page load 
document.querySelector('.js-search-header').addEventListener('click', openSearchDrawerCustom);
document.querySelector('.js-search-header-close').addEventListener('click', closeSearchDrawerCustom);
function openSearchDrawerCustom(evt) {
  evt.preventDefault();
  evt.stopImmediatePropagation();
  const currentOpenButton = evt.target
  const nearestHolder = currentOpenButton.closest('.site-header')
  const searchContainer = nearestHolder.querySelector('.site-header__search-container')
  const inputField = searchContainer.querySelector('.site-header__search-input')
  searchContainer.addEventListener('transitionend', removeClass);
  function removeClass(searchContainer) {
    searchContainer.classList.remove('is-transitioning'); 
    searchContainer.removeEventListener('transitionend', removeClass);
  }
  searchContainer.classList.add('is-transitioning');
  searchContainer.classList.add('is-active');
  document.documentElement.classList.add('js-drawer-open', 'js-drawer-open--search');
  inputField.focus();
  const searchResult = nearestHolder.querySelector('.ss__autocomplete--target')
  searchResult.style.display = 'block'

}
function closeSearchDrawerCustom(evt) {
  evt.preventDefault();
  evt.stopImmediatePropagation();
  const currentOpenButton = evt.target
  const nearestHolder = currentOpenButton.closest('.site-header')
  const searchContainer = nearestHolder.querySelector('.site-header__search-container')
  document.documentElement.classList.add('js-drawer-closing');
  document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
  window.setTimeout(function () {
    document.documentElement.classList.remove('js-drawer-closing');
  }.bind(this), 500);
  searchContainer.classList.remove('is-active');
  const searchResult = nearestHolder.querySelector('.ss__autocomplete--target')
  searchResult.style.display = 'none'
}